const LIMITS = {
    SPLASH_SCREEN_TIMEOUT: 3, // in seconds
    GAME_RETRY_TIMEOUT: 5, // in seconds
    ONBOARDING_SCREEN_TIMEOUT: 5, // in seconds
    PAGE_SIZE: 50,
    DEFAULT_PAGE: 1,
}

export default LIMITS;